<!--
 * @Description: 生产运输-运输签收、取消、修改
-->
<template>
  <el-dialog :visible="visible" title="运输信息" width="1230px" append-to-body @close="onClose" @open="onOpen">
    <div class="dialoginfo j_FZYinfo">
      <!-- <div
          :style="{
            background: '#000',
            height: '5px',
            width: '10cm',
          }"
        ></div> -->
      <el-card class="box-card">
        <div style="font-size: 21px">物流信息</div>
        <el-form ref="formData" :inline="true" :model="formData" label-width="100px">
          <el-row>
            <el-col :span="8"
              ><el-form-item label="运输号：">
                <span>{{ formData.code }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8"
              ><el-form-item label="物流状态：">
                <span>{{ formData.dataStatusName }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8"
              ><el-form-item label="物流时间：">
                <span>{{ formData.proTime }}</span>
              </el-form-item></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="8"
              ><el-form-item label="客户名称：">
                <span>{{ formData.customerName }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8"
              ><el-form-item label="工程名称：">
                <span>{{ formData.engineeringName }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8"
              ><el-form-item label="浇筑部位：">
                <span>{{ formData.structuralParts }}</span>
              </el-form-item></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="产品名称：">
                <span>{{ formData.productName }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8">
              <el-form-item label="浇筑方式：">
                <span>{{ formData.pouringMethod }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8">
              <el-form-item label="泵送单位：">
                <span>{{ formData.pumpingTeam }}</span>
              </el-form-item></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="车辆单位：">
                <span>{{ formData.affiliatedUnit }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8">
              <el-form-item prop="carNo" label="车牌号：">
                <el-select v-model="formData.carNo" :disabled="type == 2 || config.dataStatus == 8 || config.dataStatus == 4" filterable placeholder="请选择" style="width: 180px">
                  <el-option v-for="(item, index) in carList" :key="index" :label="item" :value="item"></el-option>
                </el-select> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item prop="faceValue" label="票面量：">
                <el-input
                  v-model="formData.faceValue"
                  :disabled="type == 2 || config.dataStatus == 8 || config.dataStatus == 4"
                  :rows="5"
                  style="width: 180px"
                  resize="none"
                  placeholder="请输入"
                  clearable
                  type="Number"
                ></el-input> </el-form-item
            ></el-col>
          </el-row>
          <el-row>
            <el-col :span="8"
              ><el-form-item label="生产量：">
                <span>{{ formData.proNum }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8"
              ><el-form-item label="富余量：">
                <span>{{ formData.lossNum }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8"
              ><el-form-item label="转入量：">
                <span>{{ formData.shiftTo }}</span>
              </el-form-item></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="8"
              ><el-form-item label="是否转场：">
                <el-radio-group v-model="formData.whetherTransfer" :disabled="type == 2 || config.dataStatus == 8 || config.dataStatus == 4 || formData.whetherTransferOld == '1'">
                  <el-radio label="0">否</el-radio>
                  <el-radio label="1">是</el-radio>
                </el-radio-group>
              </el-form-item></el-col
            >
            <el-col :span="8"
              ><el-form-item v-if="formData.whetherTransfer == 1" label="转场类型：">
                <el-radio-group v-model="formData.vehicleTransfer" :disabled="type == 2 || config.dataStatus == 8 || config.dataStatus == 4">
                  <el-radio label="1">站内转场</el-radio>
                  <el-radio label="2">站外转场</el-radio>
                </el-radio-group>
              </el-form-item></el-col
            >
          </el-row>
        </el-form>
      </el-card>
      <el-card v-if="type == 2" class="box-card" style="margin-top: 15px">
        <div style="font-size: 21px">离场申请信息</div>
        <el-form ref="formData2" class="formData2" :inline="true" :model="formData2" label-width="170px">
          <el-row>
            <el-col :span="8">
              <div>
                <el-form-item label="司机余料标记：">
                  <span>{{ formData2.frontIsClout == 1 ? "石" : "否" }}</span>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="重车照片：">
                <span>
                  <el-link v-if="formData2.reconditionUrl" class="table_link" :underline="false" @click="handleVideo(formData2.reconditionUrl)">查看</el-link>
                  <span v-else>-</span>
                </span>
              </el-form-item></el-col
            >
            <el-col :span="8">
              <el-form-item label="重车重量：">
                <span>{{ formData2.reconditionSiteNum }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8">
              <el-form-item label="工地过磅异常异常描述：">
                <span>{{ formData2.excetionRession }}</span>
              </el-form-item></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="空车照片：">
                <span>
                  <el-link v-if="formData2.emptyUrl" class="table_link" :underline="false" @click="handleVideo(formData2.emptyUrl)">查看</el-link>
                  <span v-else>-</span>
                </span>
              </el-form-item></el-col
            >
            <el-col :span="8">
              <el-form-item label="空车重量：">
                <span>{{ formData2.emptySiteNum }}</span>
              </el-form-item></el-col
            >
            <el-col :span="8">
              <el-form-item label="工地过磅异常异常图片：">
                <span>
                  <el-link v-if="formData2.excetionPicture" class="table_link" :underline="false" @click="handleVideo(formData2.excetionPicture)">查看</el-link>
                  <span v-else>-</span>
                </span>
              </el-form-item></el-col
            >
          </el-row>

          <div v-if="applyDetList.length > 0">
            <div v-for="(item, index) in applyDetList" :key="index">
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="'浇筑方式' + (index + 1) + ':'">
                    <span>{{ item.pouringWay }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="泵机编号/车牌号：">
                    <span>{{ item.pumpNo }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="泵送方式：">
                    <span>{{ formData.pumpWay == "1" ? "扫泵" : "手动添加" }}</span>
                  </el-form-item></el-col
                >
              </el-row>
            </div>
          </div>
        </el-form>
      </el-card>
      <el-card v-if="type == 2" class="box-card" style="margin-top: 15px">
        <div style="font-size: 21px">签收信息</div>
        <el-form ref="formData3" :inline="true" :model="formData3" label-width="100px" class="formData3">
          <el-form-item label="过磅余料量：">
            <span>{{ formData3.residueNum }}</span>
          </el-form-item>
          <el-form-item label="客户余料量：">
            <el-input v-model="formData3.clientResidueNum" :rows="5" :disabled="config.dataStatus == 4" style="width: 100px" resize="none" placeholder="请输入" clearable type="Number"></el-input>
          </el-form-item>
          <el-form-item label="异常量：">
            <span>{{ formData3.adjustNum }}</span>
          </el-form-item>
          <el-form-item label="签收量：">
            <el-input v-model="formData3.signForNum" :rows="5" :disabled="config.dataStatus == 4" style="width: 100px" resize="none" placeholder="请输入" clearable type="Number" @input="abnormalCount()"></el-input>
          </el-form-item>
        </el-form>
        <el-button size="mini" class="bottom_all" style="margin: 10px 0px" @click="addItem()"> 添加 </el-button>
        <el-table ref="formDataTable" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="structuralPartsData" tooltip-effect="dark">
          <el-table-column label="浇筑方式" align="center" width="auto">
            <template slot-scope="scope">
              <el-select v-model="scope.row.pourMethod" placeholder="请选择" style="width: 100%" value-key="id" :disabled="config.dataStatus == 4">
                <el-option v-for="(item, index) in signPourMethod" :key="index" :label="item.name" :value="item"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="泵送单位" align="center" width="auto">
            <template slot-scope="scope">
              <el-select v-model="scope.row.pourTeam" placeholder="请选择" style="width: 100%" value-key="contractId" :disabled="config.dataStatus == 4">
                <el-option v-for="(item, index) in signPourTeams" :key="index" :label="item.pumpTeamName" :value="item"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" prop="specification">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="deleteDetList(scope.$index)"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" style="margin-left: 24px" @click="onClose">关 闭</el-button>
      <el-button v-if="type == 1 && config.dataStatus !== 8 && config.dataStatus !== 4 && !isLook" class="bottom_all_two" style="margin-left: 24px" @click="cancelProDispatch()">取消送货单</el-button>
      <el-button v-if="type == 1 && config.dataStatus !== 8 && config.dataStatus !== 4 && !isLook" class="bottom_all" style="margin-left: 24px" @click="updateProDispatch()">保存送货单</el-button>
      <el-button v-if="type == 2 && config.dataStatus !== 8 && config.dataStatus !== 4 && !isLook" class="bottom_all" style="margin-left: 24px" @click="signProDispatch()">签收</el-button>
      <el-button v-if="type == 2 && config.dataStatus == 4 && !isLook" class="bottom_all" style="margin-left: 24px" @click="updateProDispatchStatus()">取消签收</el-button>
    </span>
    <!-- 查看图片 -->
    <ShowDetails :dialog="imgsDialog" :imgList="imgList" @reset="imgsDialog = false"></ShowDetails>
  </el-dialog>
</template>

<script>
import { queryProMessionById, queryStationCarNos, updateProDispatch, cancelProDispatch, signProDispatch, updateProDispatchStatus } from "@/api/smart/productTransport_outside.js";
import ShowDetails from "@/components/showdetails";
export default {
  components: {
    ShowDetails,
  },
  data() {
    return {
      formData: {},
      formData2: {},
      formData3: {},
      rules: [],
      carList: [],
      applyDetList: [],
      imgsDialog: false,
      imgList: [],
      structuralPartsData: [],
      signPourMethod: [],
      signPourTeams: [],
    };
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
    },
    isLook: {
      type: Boolean,
      default: false,
    },
    // 1取消修改 2 签收
    type: {
      type: Number,
      default: 1,
    },
  },
  watch: {},
  methods: {
    abnormalCount() {
      this.formData3.adjustNum = Number(this.$regExp.FloatMul(Number(this.formData.faceValue - this.formData3.signForNum - this.formData3.residueNum), 1)).toFixed(2);
    },
    signProDispatch() {
      for (var i = 0; i < this.structuralPartsData.length; i++) {
        if (this.structuralPartsData[i].pourMethod.type == 1 && !this.structuralPartsData[i].pourTeam) {
          this.$message.warning(`浇筑方式:${this.structuralPartsData[i].pourMethod.name}为泵送方式，请选择泵送单位`);
          return;
        }
      }
      let params = {
        id: this.config.id,
        clientResidueNum: this.formData3.clientResidueNum,
        signForNum: this.formData3.signForNum,
        structuralParts: JSON.stringify(this.structuralPartsData),
        adjustNum: this.formData3.adjustNum,
      };
      signProDispatch(params).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功");
          this.onClose();
          this.$emit("reset");
        }
      });
    },
    updateProDispatchStatus() {
      this.$confirm("确定取消签收?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          updateProDispatchStatus({ id: this.config.id, dataStatus: 6 }).then(res => {
            if (res.code === 1001) {
              this.$message.success("取消成功");
              this.onClose();
              this.$emit("reset");
            }
          });
        })
        .catch(() => {});
    },
    addItem() {
      let obj = {
        pourMethod: [],
        pourTeam: [],
      };
      this.structuralPartsData.push(obj);
    },
    deleteDetList(index) {
      this.structuralPartsData.splice(index, 1);
    },
    handleVideo(url) {
      this.imgList = url.split(",").map(res => "/file/" + res);
      this.imgsDialog = true;
    },
    onOpen() {
      this.structuralPartsData = [];
      this.queryProMessionById();
      this.queryStationCarNos();
    },
    queryProMessionById() {
      let _this = this;
      queryProMessionById({ type: this.type, logisticsId: this.config.id }).then(res => {
        if (res.code == 1001) {
          _this.formData = res.data.basicData;
          this.$set(_this.formData,'whetherTransfer',_this.formData.whetherTransfer || '0')
          this.$set(_this.formData,'whetherTransferOld',_this.formData.whetherTransfer || '0')
          this.$set(_this.formData,'vehicleTransfer',_this.formData.vehicleTransfer || '0')
          if (_this.type == 2) {
            _this.formData2 = res.data.applayData;
            _this.applyDetList = res.data.applyDetList;
            _this.signPourMethod = JSON.parse(res.data.signPourMethod);
            _this.signPourTeams = res.data.signPourTeams;
            _this.formData3 = res.data.signMap;
            _this.structuralPartsData = _this.formData3.signPourMethod ? JSON.parse(_this.formData3.signPourMethod) : [];
            _this.abnormalCount();
            //浇筑方式默认
            let planPouringMethod = _this.formData.pouringMethod.split(",");
            if (_this.applyDetList.length > 0 && _this.config.dataStatus !== 4) {
              _this.applyDetList.forEach(item => {
                let planIndex = planPouringMethod.findIndex(item2 => item2 == item.pouringWay); //判断当前浇筑方式存在计划中
                console.log(planIndex);
                if (planIndex !== -1) {
                  let pourMethod = _this.signPourMethod.findIndex(item3 => item3.id == item.pouringWayId);
                  console.log(pourMethod);
                  let pumpTeamIndex = _this.signPourTeams.findIndex(item4 => item4.contractId == item.contractId);
                  if (pourMethod !== -1) {
                    let obj = {
                      pourMethod: _this.signPourMethod[pourMethod],
                      pourTeam: pumpTeamIndex == -1 ? "" : { contractId: item.contractId, pumpTeamName: item.pumpTeamName },
                    };
                    _this.structuralPartsData.push(obj);
                  }
                }
              });
            }
          }
        }
      });
    },
    queryStationCarNos() {
      queryStationCarNos({ stationId: this.config.productionSiteId }).then(res => {
        if (res.code == 1001) {
          this.carList = res.data;
        }
      });
    },
    updateProDispatch() {
      console.log(this.formData.whetherTransfer)
      if( this.formData.whetherTransfer == '1' &&  !this.formData.vehicleTransfer) {
        this.$message.warning('请选择转场类型')
        return 
      }
      let params = {
        id: this.formData.id,
        faceValue: this.formData.faceValue, //票面量
        carNo: this.formData.carNo,
        smallType: this.formData.whetherTransfer == '0' ? '0' : this.formData.vehicleTransfer, //转场
      };
      updateProDispatch(params).then(res => {
        if (res.code === 1001) {
          this.$message.success("保存成功");
          this.onClose();
          this.$emit("reset");
        }
      });
    },
    cancelProDispatch() {
      this.$confirm("确定取消该物流?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          cancelProDispatch({ id: this.formData.id }).then(res => {
            if (res.code === 1001) {
              this.$message.success("取消成功");
              this.onClose();
              this.$emit("reset");
            }
          });
        })
        .catch(() => {});
    },
    onClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss">
.j_FZYinfo {
  .el-form-item__content {
    width: 220px;
  }
  .formDataRadio {
    .el-form-item__content {
      width: 260px !important;
    }
  }
  .formData2 {
    .el-form-item__content {
      width: 150px !important;
    }
  }
  .formData3 {
    .el-form-item__content {
      width: 120px !important;
    }
  }
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
.el-dialog__footer{
  text-align: center !important;
}
</style>